import emitter, { EventTypes } from './eventEmitter';

export default (eventName, formName, ...args) =>
  emitter.emit(EventTypes.CALL_FORM_METHOD, eventName, formName, ...args);
